



























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import TestGridOverlay from '@/components/utils/TestGridOverlay/index.vue';
import ModalWrapper from '@/components/utils/ModalWrapper/index.vue';
import ProcessBar from '@/components/ProcessBar/index.vue';
import ClickableLogo from '@/components/ClickableLogo/index.vue';
import MobileOverlay from '@/components/MobileOverlay/index.vue';
import HintTool from '@/components/HintTool/index.vue';
import { Step } from '@/components/ProcessBar/ProcessBar.models';
import { Modal } from '@/components/utils/Modal/Modal.models';
import { Route } from 'vue-router';
import { Notification } from '@/components/NotificationBanner/NotificationBanner.models';
import NotificationWrapper from '@/components/NotificationWrapper/index.vue';
import { TransitionMode, TransitionDirection, TransitionColor } from './store/modules/transitions';
import PageRouter from './components/PageRouter/index.vue';
import { gsap } from 'gsap';

const appModule = namespace('app');
const notifyModule = namespace('notify');
const transitionsModule = namespace('transitions');
const houseSizeModule = namespace('houseSize');

@Component({
  components: {
    TestGridOverlay,
    ProcessBar,
    ModalWrapper,
    ClickableLogo,
    MobileOverlay,
    NotificationWrapper,
    PageRouter,
    HintTool
  }
})
export default class Components extends Vue {
  @appModule.State private loading!: boolean;
  @appModule.State private initialized!: boolean;
  @appModule.State private processRoutes!: Step[];
  @notifyModule.State private openModals!: Modal[];
  @notifyModule.State private openNotifications!: Notification[];
  @transitionsModule.State private direction!: TransitionDirection;
  @houseSizeModule.State private videoReady!: boolean;

  @appModule.Getter private isTabletPortrait!: boolean;
  @transitionsModule.Getter private transitionMode!: TransitionMode;
  @transitionsModule.Getter private transitionColor!: TransitionColor;
  @houseSizeModule.Getter private stepCompleted!: boolean;

  @appModule.Action private setInitializedState!: () => void;
  @appModule.Action private setInitialAnimationCompleted!: () => void;
  @notifyModule.Action private openCodeModal!: () => void;
  @notifyModule.Action private closeModal!: (modalId: number) => void;
  @appModule.Action private setCurrentRoute!: (route: Route) => void;
  @notifyModule.Action private closeNotification!: (key: string) => void;
  @transitionsModule.Action private setNavigationType!: (navigation: { to: Route; from: Route }) => void;

  get showProcessBar(): boolean {
    return this.$route.meta.showProcessBar && (this.videoReady || this.stepCompleted);
  }

  get showCodeLink(): boolean {
    // TODO: getter naming might confuse them with methods
    return this.$route.meta.showCodeLink;
  }

  get showLogo(): boolean {
    return this.$route.meta.showLogo;
  }

  get isDevelopment(): boolean {
    return process.env.NODE_ENV === 'development';
  }

  @Watch('$route')
  private routeChanged(route: Route) {
    this.setCurrentRoute(route);
  }

  @Watch('loading')
  private loadingChanged(loading: boolean) {
    if (!loading && !this.initialized) {
      this.runInitialAnimation();
      this.setInitializedState();
    }
  }

  private runInitialAnimation() {
    const loaderEl: HTMLElement | null = document.querySelector('.global-loader');
    const firstAnimationBlock = this.$el.querySelector('.page-router__animation-block--first') as HTMLElement;
    const lastAnimationBlock = this.$el.querySelector('.page-router__animation-block--last') as HTMLElement;
    const routerContainerEl = this.$el.querySelector('.page-router__container') as HTMLElement;

    if (loaderEl) {
      const loadingTime = Date.now() - Number.parseInt(loaderEl.dataset.start || Date.now().toString());
      const initialDelay: number = loadingTime > 2000 ? 0 : 2000 - loadingTime;

      gsap
        .timeline({ onComplete: this.setInitialAnimationCompleted })
        .set(this.$el, { backgroundColor: '#e1e0e5' })
        .fromTo(loaderEl, { opacity: 1 }, { opacity: 0, duration: 0.5, delay: initialDelay / 1000 })
        .fromTo(
          firstAnimationBlock,
          { xPercent: -100, backgroundColor: '#f2eeee' },
          { xPercent: 0, duration: 0.8 },
          '>'
        )
        .fromTo(
          lastAnimationBlock,
          { xPercent: -100, backgroundColor: '#fff' },
          { xPercent: 0, duration: 0.8, delay: 0.2 },
          '<'
        )
        .set(this.$el, { clearProps: 'all' }, '>')
        .set(firstAnimationBlock, { clearProps: 'all' }, '>')
        .set(lastAnimationBlock, { clearProps: 'all' }, '>')
        .fromTo(routerContainerEl, { opacity: 0 }, { opacity: 1, duration: 1.5 });
    }
  }
}
